<template>
    <div class="fadein">
        <div class="h30"></div>
        <div class="center1200 bg-white temp-1 shadow">
            <div class="h20"></div>
            <div class="center-title">
              <a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> 电影分类 <img class="title-pic" src="/static/img/title-right.png" alt=""></a>
            </div>
            <div class="h20"></div>
      
            <div class="categorys">
              <div class="category" v-for="v in all_cate"><a href="javascript:;" @click="goCategory(v.type)" style="display: block;">{{v.type}}</a></div>
              <div style="width:270px;" v-for="n in flex_cates_align"></div>

            </div>
      
            <div class="h10"></div>
      
          </div>
          <Goback></Goback>

        <div class="h30"></div>
    </div>
</template>
<script>
  import Goback from '@/components/components/goback'
  export default{
    components:{
        Goback,

    },
    data(){
      return {
        all_cate:[],
        flex_cates_align:0,
      }
    },
    watch: {
    //路由改变时执行
      $route(newVal, oldVal) {
        if(newVal.name == 'category'){
          this.$parent.activeIndex = '3'
        }
      }
    },
    mounted() {
      this.getAllCate();
    },
    methods:{
      getAllCate(){
        $.ajax({
          url:"//"+ this.$API_URL +"/api/v1/movies/types",
          type:"get",
          success:(ret)=>{
            if(ret.code==200){
              this.all_cate = ret.data.data
              
              this.flex_cates_align = 4 - (this.all_cate.length % 4)
            }
          }
        })
      },
      //去分类详情
      goCategory(keyword){
        this.$router.push('/categorydetail/'+keyword);
      },
    },
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/category.vue